'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** The icon a state draws in the status circle; a SPINNING state draws a spinner in CSS. */
const STATE_ICON = {
    succeeded: '✓',
    failed: '✕',
    denied: '✕',
};
/** States whose circle is a CSS spinner: running, and parked on a long-running job (COP-156 D6). */
const SPINNING = new Set(['running', 'awaiting_job']);
/**
 * ONE action, drawn the same wherever the Copilot shows one: a status circle
 * (✓ done, ✕ failed or denied, a spinner while running or waiting on a job, the step number or an
 * empty ring otherwise), the name with its outcome on the right, then optional
 * meta and note lines. Plan card steps and turn action rows both render
 * through it, so an action reads the same on the card and in the list.
 *
 * Every part is a `span` (made block-level in CSS) so a row keeps its
 * elements in the order screen readers and tests read them.
 */
export function CopilotActionItem({ as: Tag = 'div', state, marker, title, outcome, meta, children, className, ...rest }) {
    return (_jsxs(Tag, { className: ['copilot-action-item', className].filter(Boolean).join(' '), ...rest, "data-action-state": state, children: [_jsx("span", { className: "copilot-action-item-marker", "aria-hidden": "true", children: STATE_ICON[state] ?? (SPINNING.has(state) ? null : marker) }), _jsxs("span", { className: "copilot-action-item-head", children: [_jsx("span", { className: "copilot-action-item-title", children: title }), outcome] }), meta ? _jsx("span", { className: "copilot-action-item-meta", children: meta }) : null, children] }));
}
//# sourceMappingURL=action-item.js.map